import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const OptionalSettingsLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${owcTheme['one-spacer-px-16']};
`;

export const OptionalSettingTextLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${owcTheme['one-spacer-px-4']};
`;
